module.exports = __webpack_public_path__ + "static/media/symbol.8591a6cb.png";